import Layout from 'components/shared/Layout'
import Link from 'components/shared/Link'
import ArrowLink from 'components/shared/ArrowLink'

import css from './styles.module.scss'

const BackToList = ({ className, text, url, contentType }) => (
  <Layout className={className} type="wrapper">
    <Link className={css.link} to={url} href={url} contentType={contentType}>
      <ArrowLink tag="li" theme="purple" className={css.link} reversed>
        {text}
      </ArrowLink>
    </Link>
  </Layout>
)

export default BackToList
